import { BREAKPOINTS } from '../constants'
import { defaultPreset } from './default'

/**
 * Legacy slider3col / block-pushes / comparisons preset.
 * Mobile-first: 1 slide (auto width) → 2 → 3 columns.
 */
export const threeColPreset = {
  ...defaultPreset,
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 16,
  centeredSlides: false,
  slideToClickedSlide: true,
  navigation: {
    enabled: false,
  },
  breakpoints: {
    [BREAKPOINTS.SM]: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 16,
    },
    [BREAKPOINTS.MD]: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 24,
    },
    [BREAKPOINTS.LG]: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 40,
      navigation: {
        enabled: true,
      },
    },
  },
}
